var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { DeskPool } from '../../DeskPool';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { selectVoteDirection, startPlayerIntroduction, } from '../../../../api';
import styled from 'styled-components';
const Wrapper = styled.div `
  position: absolute;
  top: 153px;
  left: 430px;

  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 263px;
  padding: 20px 25px;

  font-family: 'Inter';
  font-size: 16px;
  line-height: 24px;
  color: #fff;

  border: 1px solid rgba(0, 241, 227, 1);
  border-radius: 15px;
`;
export function SelectRoundDirection({ useCase }) {
    var _a;
    const { param: matchId } = useQuery('matchId');
    const matchState = useAppSelector(selectMatchState);
    const dispatch = useAppDispatch();
    const { errorHandler } = useErrorHandler(matchId);
    const [candidate, setCandidate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const isMountedRef = useRef(true);
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const candidates = ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.candidates) || [];
    const onGameButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        if (candidate === null) {
            return;
        }
        if (!isMountedRef.current)
            return;
        setIsLoading(true);
        try {
            if (useCase === 'INTRODUCTION') {
                const result = yield startPlayerIntroduction(candidate.player.id);
                if (isMountedRef.current) {
                    dispatch(setMatchState(result));
                }
            }
            else {
                const result = yield selectVoteDirection(candidate.player.id, candidate.direction);
                if (isMountedRef.current) {
                    dispatch(setMatchState(result));
                }
            }
        }
        catch (err) {
            if (isMountedRef.current) {
                errorHandler(err);
            }
        }
        finally {
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        }
    });
    const onPlayerClickAction = (playerId) => {
        const found = candidates.find((c) => c.id === playerId);
        if (found) {
            const player = matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
            if (player) {
                const newCandidate = {
                    player,
                    direction: found.direction,
                };
                setCandidate(newCandidate);
            }
        }
    };
    const gameButtonState = {
        text: isLoading ? 'Выполняется...' : `${candidate === null || candidate === void 0 ? void 0 : candidate.player.player.gameName} начал(а)`,
        visible: candidate !== null,
        onClick: onGameButtonClick,
        disabled: isLoading,
    };
    const getAddOnComponent = () => (_jsx(Wrapper, { children: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0433\u0440\u043E\u043A \u043F\u043E \u043B\u0435\u0432\u0443\u044E \u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u0443\u044E \u0440\u0443\u043A\u0443 \u043E\u0442 \u043D\u0430\u0447\u0430\u0432\u0448\u0435\u0433\u043E" }));
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState, addOnComponent: getAddOnComponent }));
}
